import React from 'react'
import UiInputText from "../components/Form/UiInputText";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import FormContainer from '../components/Form/FormContainer';
import Button from 'react-bootstrap/Button';
import UiInputList from "../components/Form/UiInputList";
import UiInputMoney from "../components/Form/UiInputMoney";
import UiInputCheckbox from "../components/Form/UiInputCheckbox";

export default function ContaFinanceiraForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { ativo: true }
    });
    const { handleSubmit } = methods;

    const tipoList = [
        { id: 'banco', title: 'Banco' },
        { id: 'caixa', title: 'Caixa' },
        { id: 'pix', title: 'PIX' },
        { id: 'carteira_digital', title: 'Carteira Digital' },
        { id: 'outro', title: 'Outro' },
    ];

    return (
        <FormContainer size="md" show={true} onHide={props.triggerClose}>
            <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <FormContainer.Header onClose={props.triggerClose}>
                        <h5>{props.data?.id ? 'Editar Conta Financeira' : 'Nova Conta Financeira'}</h5>
                    </FormContainer.Header>
                    <FormContainer.Body>
                        <div className="row">
                            <UiInputText size={8} name="nome" label="Nome" required />
                            <UiInputList size={4} name="tipo" list={tipoList} idField="id" titleField="title" label="Tipo" required />
                            <UiInputMoney size={4} name="saldoInicial" label="Saldo Inicial" />
                            <UiInputCheckbox size={4} name="ativo" label="Ativo" />
                        </div>
                    </FormContainer.Body>
                    <FormContainer.Footer>
                        <Button variant="secondary" onClick={props.triggerClose}>Fechar</Button>
                        <Button variant="primary" type="submit">Salvar</Button>
                    </FormContainer.Footer>
                </Form>
            </FormProvider>
        </FormContainer>
    )
}
